import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
// in the future this can be replaced by an external API that saves user preferences
export class LocalStorageService {
  private _notificationDrawerReadKeys: string = 'notificationDrawerReadKeys';

  get notificationDrawerReadKeys(): string {
    return this._notificationDrawerReadKeys;
  }

  getItem(item: string): any {
    return localStorage.getItem(item);
  }

  setItem(item: string, content: any): void {
    localStorage.setItem(item, content);
  }

  removeItem(item: string): void {
    localStorage.removeItem(item);
  }
}
